var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.useGroupedListMode)?_c('ListView',{attrs:{"response":_vm.response}}):_vm._e(),(_vm.useGroupedListMode)?_c('ListViewGrouped',{attrs:{"response":_vm.response}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }